import { render, staticRenderFns } from "./WebsiteSettings.vue?vue&type=template&id=4924abfe&"
import script from "./WebsiteSettings.vue?vue&type=script&lang=ts&"
export * from "./WebsiteSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports